export const styles = {
  paperText: {
    display: 'flex',
    width: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  itemSimpleContent: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#424550',

    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px !important',
      lineHeight: '146%',
      color: '#23252F',
    },
  },
  itemContent: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#424550',

    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px !important',
      lineHeight: '146%',
      color: '#23252F',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  selectionItemContent: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#424550',

    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px !important',
      lineHeight: '146%',
      color: '#23252F',
    },
  },
};
